/**
 * 解析Url的参数和hash
 * @return { [key: string]: any, HASH?: string }
 */
export const getQuery = () => {
  const result = {};
  const url = window.location.href;
  const reg1 = /([^?=&#]+)=([^?=&#]+)/g;
  const reg2 = /#([^?=&#]+)/g;
  url.replace(reg1, (n, x, y) => (result[x] = y));
  url.replace(reg2, (n, x) => (result['HASH'] = x));
  return result;
};

// 获取url参数和Hash
export const queryParams = getQuery();
